
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7iIKP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $4nIKB = parcelRequire("4nIKB");


var $iDrrr = parcelRequire("iDrrr");


var $4n1IT = parcelRequire("4n1IT");


var $8gDjG = parcelRequire("8gDjG");


var $ghNlj = parcelRequire("ghNlj");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");


var $bErsF = parcelRequire("bErsF");


var $3OPLu = parcelRequire("3OPLu");


var $8LUcH = parcelRequire("8LUcH");


var $lcVcg = parcelRequire("lcVcg");


var $bQTMi = parcelRequire("bQTMi");


var $o0Pq1 = parcelRequire("o0Pq1");


var $b10cD = parcelRequire("b10cD");


var $3VFMF = parcelRequire("3VFMF");


var $jvvj0 = parcelRequire("jvvj0");


var $19KIY = parcelRequire("19KIY");


var $7PUZv = parcelRequire("7PUZv");


var $f2FAo = parcelRequire("f2FAo");

const $2fb8d68051612d7a$var$emptyEntryPointParams = {};
const $2fb8d68051612d7a$var$emptyEntryPointProps = {};
const $2fb8d68051612d7a$var$FallbackComponent = ({ fallback: fallback, loadingText: loadingText, onMount: onMount, onUnmount: onUnmount, onFocusStateChange: onFocusStateChange, shouldFocus: shouldFocus, role: role })=>{
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (shouldFocus) {
            if ((0, $iDrrr.fg)('platform_dst-automated_focus')) {
                const container = ref.current?.parentElement;
                if (container && (0, $19KIY.isFocusMovingRole)({
                    role: role
                })) (0, $8gDjG.applyInitialFocus)({
                    container: container,
                    initialFocusRef: ref,
                    role: role
                });
            } else ref.current?.focus();
        }
        onMount();
        return ()=>onUnmount();
    }, [
        onMount,
        onUnmount,
        shouldFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: ref,
        tabIndex: shouldFocus ? -1 : undefined,
        "data-testid": "popup-trigger-loading",
        onBlur: ()=>onFocusStateChange(false),
        onFocus: ()=>onFocusStateChange(true)
    }, fallback || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7PUZv.Loading), {
        loadingText: loadingText
    }));
};
/**
 * Whether the popup's own initial focus target should be forwarded to the
 * entry point and used to restore focus.
 *
 * Both gates are always read, rather than short-circuited, so that each gate
 * is accessed regardless of the other gate's value.
 */ function $2fb8d68051612d7a$var$isInitialFocusForwardingEnabled() {
    const isAutomatedFocusEnabled = (0, $iDrrr.fg)('platform_dst-automated_focus');
    const isInitialFocusRefEnabled = (0, $iDrrr.fg)('platform_dst-popup-trigger-initial-focus-ref');
    return isAutomatedFocusEnabled || isInitialFocusRefEnabled;
}
function $2fb8d68051612d7a$export$95d4acdbab2fc6ef({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, errorText: errorText, errorTitle: errorTitle, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, onClose: onClose, onPopupOpen: onPopupOpen, preloadOnFocus: preloadOnFocus = true, autoFocus: autoFocus, loadingText: loadingText = 'Loading popup...', loadingCompleteText: loadingCompleteText = 'Loading is complete.', shouldCloseOnItemClick: shouldCloseOnItemClick = false, ...popupProps }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const id = (0, $cozmU.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [content, setContent] = (0, $cozmU.useState)(null);
    const { statusText: statusText, announce: announce, cancelPendingAnnouncement: cancelPendingAnnouncement, resetStatus: resetStatus } = (0, $lcVcg.useStatusAnnouncement)();
    const isOpenRef = (0, $cozmU.useRef)(false);
    const hasErrorRef = (0, $cozmU.useRef)(false);
    const triggerFocusRef = (0, $cozmU.useRef)(null);
    const updateRef = (0, $cozmU.useRef)(null);
    const setInitialFocusRef = (0, $cozmU.useRef)(null);
    const initialFocusRef = (0, $cozmU.useRef)(null);
    const shouldTransferFocusRef = (0, $cozmU.useRef)(false);
    const handleError = (0, $cozmU.useCallback)((props)=>{
        if (isOpenRef.current) {
            hasErrorRef.current = true;
            resetStatus();
            announce({
                text: errorText ?? (0, $o0Pq1.defaultErrorText),
                clearAfter: 5000
            });
        }
        onError?.(props);
    }, [
        announce,
        errorText,
        onError,
        resetStatus
    ]);
    const handleOpen = (0, $cozmU.useCallback)(()=>{
        isOpenRef.current = true;
        setIsOpen(true);
        // Notify at activation time, before popup content is queued for rendering. The native
        // opening listener can commit state before the trigger's React onClick runs.
        onPopupOpen?.();
    }, [
        onPopupOpen
    ]);
    const handleClose = (0, $cozmU.useCallback)((event, currentLevel)=>{
        isOpenRef.current = false;
        setIsOpen(false);
        if ($2fb8d68051612d7a$var$isInitialFocusForwardingEnabled() && popupProps.shouldReturnFocus !== false && event?.type === 'keydown' && 'key' in event && (event.key === 'Escape' || event.key === 'Esc')) setTimeout(()=>{
            if (document.activeElement === document.body) triggerFocusRef.current?.focus();
        }, 0);
        resetStatus();
        onClose?.(event, currentLevel);
    }, [
        onClose,
        popupProps.shouldReturnFocus,
        resetStatus,
        triggerFocusRef
    ]);
    // Content that closes the popup from its own item handler has already closed it by the time
    // this runs, so it must not report a second close.
    const handleItemClick = (0, $cozmU.useCallback)((event)=>{
        if (isOpenRef.current) handleClose(event);
    }, [
        handleClose
    ]);
    const triggerCloseRef = (0, $f2FAo.useClickToCloseRef)({
        isOpen: isOpen,
        handleClose: handleClose
    });
    const { onContentReady: onContentReady, resetContentReady: resetContentReady, waitForContentReady: waitForContentReady } = (0, $8LUcH.useContentReadySignal)();
    const load = (0, $cozmU.useCallback)(()=>(0, $6SsN4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $2fb8d68051612d7a$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const popupSetInitialFocusRef = (0, $cozmU.useRef)(null);
    const handleSetInitialFocusRef = (0, $cozmU.useCallback)((el)=>{
        initialFocusRef.current = el;
        popupSetInitialFocusRef.current?.(el);
    }, []);
    const onLoad = (0, $cozmU.useCallback)(({ reference: entryPointReference })=>{
        // Use the rendered open state: the separate close listener may already have
        // reset isOpenRef on this click. Reading that ref would reopen the popup.
        if (isOpen) return;
        resetContentReady();
        hasErrorRef.current = false;
        shouldTransferFocusRef.current = false;
        handleOpen();
        const entryPointContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPFqZ.InternalEntryPointContainer), {
            id: id,
            onContentReady: onContentReady,
            entryPointReference: entryPointReference,
            fallback: // when the fallback is unmounted we want to trigger an update to the popup position
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2fb8d68051612d7a$var$FallbackComponent, {
                fallback: fallback,
                loadingText: loadingText,
                onMount: ()=>{
                    announce({
                        text: loadingText,
                        delay: 100
                    });
                },
                onUnmount: ()=>{
                    if (!hasErrorRef.current) {
                        const wasPending = cancelPendingAnnouncement();
                        if (!wasPending && isOpenRef.current) announce({
                            text: loadingCompleteText,
                            clearAfter: 5000
                        });
                    }
                    return updateRef.current?.();
                },
                onFocusStateChange: (wasFocused)=>{
                    shouldTransferFocusRef.current = wasFocused;
                },
                shouldFocus: autoFocus !== false,
                role: popupProps.role
            }),
            errorFallback: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b10cD.FocusErrorExperience), {
                    role: popupProps.role,
                    shouldFocus: autoFocus !== false,
                    shouldTransferFocusRef: shouldTransferFocusRef,
                    triggerRef: triggerFocusRef
                }, errorFallback ? errorFallback(props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bErsF.ErrorContent), {
                    title: errorTitle,
                    errorText: errorText ?? (0, $o0Pq1.defaultErrorText)
                })),
            runtimeProps: {
                ...entryPointProps ?? $2fb8d68051612d7a$var$emptyEntryPointProps,
                onContentResized: ()=>{
                    updateRef.current?.();
                },
                onClose: handleClose,
                ...$2fb8d68051612d7a$var$isInitialFocusForwardingEnabled() ? {
                    setInitialFocusRef: handleSetInitialFocusRef
                } : {}
            },
            onError: handleError,
            forcedError: forcedReportErrorUFO
        });
        setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldCloseOnItemClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bQTMi.CloseOnItemClick), {
            onItemClick: handleItemClick
        }, entryPointContainer) : entryPointContainer, autoFocus !== false && ((0, $iDrrr.fg)('platform_dst-popup-trigger-focus-container') && !(0, $iDrrr.fg)('platform_dst-automated_focus') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jvvj0.FocusOnContainerOnLoad), {
            entryPointReference: entryPointReference,
            setInitialFocusRef: setInitialFocusRef,
            waitForContentReady: waitForContentReady
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3VFMF.FocusInsideOnLoad), {
            entryPointReference: entryPointReference,
            initialFocusRef: initialFocusRef,
            role: popupProps.role,
            setInitialFocusRef: setInitialFocusRef,
            shouldTransferFocusRef: shouldTransferFocusRef,
            triggerRef: triggerFocusRef,
            waitForContentReady: waitForContentReady
        }))));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        errorText,
        errorTitle,
        handleOpen,
        handleError,
        announce,
        cancelPendingAnnouncement,
        handleClose,
        handleSetInitialFocusRef,
        autoFocus,
        loadingCompleteText,
        loadingText,
        onContentReady,
        resetContentReady,
        shouldCloseOnItemClick,
        waitForContentReady,
        handleItemClick,
        popupProps.role
    ]);
    const triggerRef = (0, $ghNlj.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const popupTrigger = (0, $cozmU.useCallback)((triggerProps)=>{
        const mergedRef = (0, $4nIKB.mergeRefs)([
            triggerRef,
            triggerProps.ref,
            triggerCloseRef,
            triggerFocusRef
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        triggerRef,
        triggerCloseRef,
        triggerFocusRef
    ]);
    const popupContent = (0, $cozmU.useCallback)(({ update: update, setInitialFocusRef: setInitialFocusRef })=>{
        updateRef.current = update;
        if ($2fb8d68051612d7a$var$isInitialFocusForwardingEnabled()) popupSetInitialFocusRef.current = setInitialFocusRef;
        return content;
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        ...popupProps,
        autoFocus: autoFocus,
        UNSAFE__disableInitialAutoFocus: (0, $iDrrr.fg)('platform_dst-automated_focus'),
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        // Run time passes the setter for every role; the types hide it. Goes at the flag cleanup.
        content: popupContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3OPLu.StatusAnnouncement), null, statusText));
}
module.exports["PopupTrigger"] = $2fb8d68051612d7a$export$95d4acdbab2fc6ef;

});

parcelRegister("bErsF", function(module, exports) {
/* error-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $24dy7 = parcelRequire("24dy7");


var $4ez2K = parcelRequire("4ez2K");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");

const $90af8d88fc702176$var$styles = {
    errorContainer: "_4ouGXIoaux _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
};
function $90af8d88fc702176$export$a9f602ed820d9782({ errorText: errorText, title: title }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "center",
        xcss: $90af8d88fc702176$var$styles.errorContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small",
        as: "h2"
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, errorText)));
}
module.exports["ErrorContent"] = $90af8d88fc702176$export$a9f602ed820d9782;

});

parcelRegister("3OPLu", function(module, exports) {
/* status-announcement.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $9GVkD = parcelRequire("9GVkD");

const $c12c91709604d524$var$styles = {
    container: "_1mT5xdy1CL _2I62gzdnbC _3iC0zddnbC _39xV02dnbC _0jFU0VdnbC _1pp6NdYbGa"
};
function $c12c91709604d524$export$1144e05dc01c8ac({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c12c91709604d524$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        role: "status"
    }, children));
}
module.exports["StatusAnnouncement"] = $c12c91709604d524$export$1144e05dc01c8ac;

});

parcelRegister("lcVcg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $2624bb52aa40c2d1$export$f2e04a9fdd1a3236() {
    const [statusText, setStatusText] = (0, $cozmU.useState)('');
    const announceTimeout = (0, $cozmU.useRef)(null);
    const clearTimeoutRef = (0, $cozmU.useRef)(null);
    const cancelPendingAnnouncement = (0, $cozmU.useCallback)(()=>{
        if (announceTimeout.current === null) return false;
        clearTimeout(announceTimeout.current);
        announceTimeout.current = null;
        return true;
    }, []);
    const cancelClear = (0, $cozmU.useCallback)(()=>{
        if (clearTimeoutRef.current !== null) {
            clearTimeout(clearTimeoutRef.current);
            clearTimeoutRef.current = null;
        }
    }, []);
    const resetStatus = (0, $cozmU.useCallback)(()=>{
        cancelPendingAnnouncement();
        cancelClear();
        setStatusText('');
    }, [
        cancelPendingAnnouncement,
        cancelClear
    ]);
    const announce = (0, $cozmU.useCallback)(({ text: text, delay: delay = 0, clearAfter: clearAfter })=>{
        cancelPendingAnnouncement();
        cancelClear();
        const publish = ()=>{
            announceTimeout.current = null;
            setStatusText(text);
            if (clearAfter !== undefined) clearTimeoutRef.current = setTimeout(()=>{
                setStatusText('');
                clearTimeoutRef.current = null;
            }, clearAfter);
        };
        if (delay === 0) publish();
        else announceTimeout.current = setTimeout(publish, delay);
    }, [
        cancelPendingAnnouncement,
        cancelClear
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            cancelPendingAnnouncement();
            cancelClear();
        }, [
        cancelPendingAnnouncement,
        cancelClear
    ]);
    return {
        statusText: statusText,
        announce: announce,
        cancelPendingAnnouncement: cancelPendingAnnouncement,
        resetStatus: resetStatus
    };
}
module.exports["useStatusAnnouncement"] = $2624bb52aa40c2d1$export$f2e04a9fdd1a3236;

});

parcelRegister("bQTMi", function(module, exports) {
/* close-on-item-click.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cbY7C = parcelRequire("cbY7C");

const $ed83981ddf84ec4a$var$styles = {
    root: "_3iDTPbcK7c"
};
const $ed83981ddf84ec4a$var$nativeItemSelector = 'a[href], button';
const $ed83981ddf84ec4a$var$itemSelector = `${$ed83981ddf84ec4a$var$nativeItemSelector}, [role="menuitem"]`; /**
                                                                  * Items that keep the popup open: they are unavailable, they open or expand something the user
                                                                  * still needs the popup for, or they toggle a selection the user may change several times.
                                                                  */ 
const $ed83981ddf84ec4a$var$keepsPopupOpenSelector = [
    '[aria-disabled="true"]',
    '[aria-expanded]',
    '[aria-haspopup]:not([aria-haspopup="false"])',
    '[role="menuitemcheckbox"]',
    '[role="menuitemradio"]'
].join(', '); // The surfaces ADS layers render: the legacy popup wrapper, top-layer popovers, and dialogs.
const $ed83981ddf84ec4a$var$layerSelector = '[data-ds--level], [popover], dialog, [role="dialog"]';
function $ed83981ddf84ec4a$var$getClosingItem(boundary, event) {
    // Modifier clicks open links in a new tab or window, so the user is still here.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return null;
    if (!(event.target instanceof Element)) return null;
    const item = event.target.closest($ed83981ddf84ec4a$var$itemSelector); // Containment is checked in the DOM, so a layer the content opens in a portal — a modal, say —
    // does not count as the content. A layer it opens inline is inside the boundary, so the item
    // must also share the boundary's nearest layer.
    if (!item || !boundary.contains(item) || item.closest($ed83981ddf84ec4a$var$layerSelector) !== boundary.closest($ed83981ddf84ec4a$var$layerSelector) || item.matches($ed83981ddf84ec4a$var$keepsPopupOpenSelector)) return null;
    return item;
}
function $ed83981ddf84ec4a$export$f18d42803ecfe229({ children: children, onItemClick: onItemClick }) {
    const boundaryRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const boundary = boundaryRef.current;
        if (!boundary) return;
         // Listening on the document in the bubble phase runs after React has dispatched the event to
        // the item, which it does from its root container. An item that stops propagation keeps the
        // popup open.
        return (0, $cbY7C.bindAll)(boundary.ownerDocument, [
            {
                type: 'click',
                listener: (event)=>{
                    if ($ed83981ddf84ec4a$var$getClosingItem(boundary, event)) onItemClick(event);
                }
            },
            {
                // Enter on a link or button dispatches a click, which the listener above handles. No
                // click follows when the item handles Enter itself and prevents the default, as router
                // links do, or when the item is not a native link or button.
                type: 'keydown',
                listener: (event)=>{
                    if (event.key !== 'Enter' || event.repeat) return;
                    const item = $ed83981ddf84ec4a$var$getClosingItem(boundary, event);
                    if (item && (event.defaultPrevented || !item.matches($ed83981ddf84ec4a$var$nativeItemSelector))) onItemClick(event);
                }
            }
        ]);
    }, [
        onItemClick
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ref: boundaryRef,
        className: (0, $hekY6.default)([
            $ed83981ddf84ec4a$var$styles.root
        ])
    }, children);
}
module.exports["CloseOnItemClick"] = $ed83981ddf84ec4a$export$f18d42803ecfe229;

});

parcelRegister("o0Pq1", function(module, exports) {
const $7e29e0f6cd3190d8$export$73e31d6dbeb74c41 = 'Something went wrong while loading the popup content.';
module.exports["defaultErrorText"] = $7e29e0f6cd3190d8$export$73e31d6dbeb74c41;

});

parcelRegister("b10cD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $8gDjG = parcelRequire("8gDjG");


var $fsWlf = parcelRequire("fsWlf");

function $4c383a9f73283a1f$export$3b3dbedadc5a6ab9({ children: children, role: role, shouldFocus: shouldFocus, shouldTransferFocusRef: shouldTransferFocusRef, triggerRef: triggerRef }) {
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldFocus || !(0, $iDrrr.fg)('platform_dst-automated_focus')) return;
        const container = ref.current?.parentElement;
        if (!container || !(0, $fsWlf.shouldMoveFocus)({
            container: container,
            role: role,
            shouldTransferFocusRef: shouldTransferFocusRef,
            triggerRef: triggerRef
        })) return;
        const result = (0, $8gDjG.applyInitialFocus)({
            container: container,
            role: role
        });
        if (!result.applied) (0, $8gDjG.applyInitialFocus)({
            container: container,
            initialFocusRef: ref,
            role: role
        });
    }, [
        role,
        shouldFocus,
        shouldTransferFocusRef,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: ref,
        tabIndex: shouldFocus ? -1 : undefined
    }, children);
}
module.exports["FocusErrorExperience"] = $4c383a9f73283a1f$export$3b3dbedadc5a6ab9;

});

parcelRegister("fsWlf", function(module, exports) {

var $19KIY = parcelRequire("19KIY");

function $92d1ed48298e6286$export$9c43340be6393b15({ container: container, role: role, shouldTransferFocusRef: shouldTransferFocusRef, triggerRef: triggerRef }) {
    if (!(0, $19KIY.isFocusMovingRole)({
        role: role
    })) return false;
    const activeElement = container.ownerDocument.activeElement;
    return shouldTransferFocusRef.current || container.contains(activeElement) || activeElement === triggerRef.current;
}
module.exports["shouldMoveFocus"] = $92d1ed48298e6286$export$9c43340be6393b15;

});

parcelRegister("19KIY", function(module, exports) {
function $e0a7b9dc63685edb$export$f52dd3ecbda3822c({ role: role }) {
    return role === 'dialog' || role === 'alertdialog' || role === 'menu' || role === 'listbox';
}
module.exports["isFocusMovingRole"] = $e0a7b9dc63685edb$export$f52dd3ecbda3822c;

});

parcelRegister("3VFMF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $8gDjG = parcelRequire("8gDjG");


var $3hJ5V = parcelRequire("3hJ5V");


var $8PrO7 = parcelRequire("8PrO7");


var $fsWlf = parcelRequire("fsWlf");

function $2b6b0ebdf1dfa03b$export$eb58c1f6b41ee511({ entryPointReference: entryPointReference, initialFocusRef: initialFocusRef, role: role, setInitialFocusRef: setInitialFocusRef, shouldTransferFocusRef: shouldTransferFocusRef, triggerRef: triggerRef, waitForContentReady: waitForContentReady }) {
    const handleLoad = (0, $cozmU.useCallback)((container)=>{
        if ((0, $iDrrr.fg)('platform_dst-automated_focus')) {
            const initialFocusTarget = initialFocusRef.current;
            const hasInitialFocusTarget = initialFocusTarget !== null && container.contains(initialFocusTarget);
            if (!hasInitialFocusTarget && !(0, $fsWlf.shouldMoveFocus)({
                container: container,
                role: role,
                shouldTransferFocusRef: shouldTransferFocusRef,
                triggerRef: triggerRef
            })) return;
            if (hasInitialFocusTarget) {
                // An entry point explicitly selected this target. Unlike the role-based
                // defaults below, it must take precedence even for roles such as
                // `tooltip` that do not otherwise move focus.
                initialFocusTarget.focus();
                return;
            }
            const result = (0, $8gDjG.applyInitialFocus)({
                container: container,
                role: role
            });
            if (!result.applied) {
                container.tabIndex = -1;
                (0, $8gDjG.applyInitialFocus)({
                    container: container,
                    initialFocusRef: {
                        current: container
                    },
                    role: role
                });
            }
            return;
        }
        // Focus the first focusable element of the loaded experience, or the
        // popup itself when the experience has nothing focusable in it.
        const target = (0, $3hJ5V.getFirstFocusable)({
            container: container
        }) ?? container;
        // The popup focuses its initial target once, when it opens. If that has
        // not happened yet — because the entry point was already loaded — this
        // makes the popup focus the target instead of itself, avoiding focus
        // moving twice.
        setInitialFocusRef.current?.(target);
        target.focus();
    }, [
        initialFocusRef,
        role,
        setInitialFocusRef,
        shouldTransferFocusRef,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8PrO7.FocusOnLoad), {
        entryPointReference: entryPointReference,
        onLoad: handleLoad,
        waitForContentReady: waitForContentReady
    });
}
module.exports["FocusInsideOnLoad"] = $2b6b0ebdf1dfa03b$export$eb58c1f6b41ee511;

});

parcelRegister("8PrO7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $izYSM = parcelRequire("izYSM");

function $f31545c2e202f38f$var$FocusOnLoadInner({ onLoad: onLoad, waitForContentReady: waitForContentReady }) {
    const anchorRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        // `Popup` does not expose a ref to the element wrapping its content, so
        // it is resolved through this anchor, which renders as a sibling of the
        // loaded experience inside that element.
        const container = anchorRef.current?.parentElement;
        if (!container) return;
        const focusContent = ()=>onLoad(container);
        if (!(0, $iDrrr.fg)('platform_dst-trigger-focus-after-content')) {
            focusContent();
            return;
        }
        return waitForContentReady(focusContent);
    }, [
        onLoad,
        waitForContentReady
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: anchorRef,
        hidden: true
    });
}
function $f31545c2e202f38f$export$192b96059b53397f({ entryPointReference: entryPointReference, onLoad: onLoad, waitForContentReady: waitForContentReady }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $izYSM.WaitForEntryPointLoad), {
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f31545c2e202f38f$var$FocusOnLoadInner, {
        onLoad: onLoad,
        waitForContentReady: waitForContentReady
    }));
}
module.exports["FocusOnLoad"] = $f31545c2e202f38f$export$192b96059b53397f;

});

parcelRegister("jvvj0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8PrO7 = parcelRequire("8PrO7");

function $6e78c277db75e1ef$export$82324a1aa77ecbcc({ entryPointReference: entryPointReference, setInitialFocusRef: setInitialFocusRef, waitForContentReady: waitForContentReady }) {
    const handleLoad = (0, $cozmU.useCallback)((container)=>{
        setInitialFocusRef.current?.(container);
        container.focus();
    }, [
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8PrO7.FocusOnLoad), {
        entryPointReference: entryPointReference,
        onLoad: handleLoad,
        waitForContentReady: waitForContentReady
    });
}
module.exports["FocusOnContainerOnLoad"] = $6e78c277db75e1ef$export$82324a1aa77ecbcc;

});

parcelRegister("7PUZv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $2XUAV = parcelRequire("2XUAV");

const $9b9e54abd66360b1$var$spinnerContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
function $9b9e54abd66360b1$export$669f6ea7d267feaf({ loadingText: loadingText }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $9b9e54abd66360b1$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2XUAV.LoadingContent), {
        loadingText: loadingText ?? 'Loading popup...',
        size: "small"
    }));
}
module.exports["Loading"] = $9b9e54abd66360b1$export$669f6ea7d267feaf;

});

parcelRegister("f2FAo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $c47b5f752a74b79b$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const clickListener = ()=>{
            if (isOpen) handleClose(null);
        };
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('click', clickListener);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            el.removeEventListener('click', clickListener);
        };
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}
module.exports["useClickToCloseRef"] = $c47b5f752a74b79b$export$46ec6629f411921d;

});


//# sourceMappingURL=render.6b12d3f8.js.map
